var Base = (function () {
    function Base(_j) {
        this._j = _j;
    }
    return Base;
}());
export { Base };
